import { ICurrentUser } from '../model/types';

/**
 * Returns the initials from a user's name string, in uppercase.
 * @param user - The user object or undefined
 * @returns The initials in uppercase (e.g., 'John Doe' -> 'JD') or empty string if user is undefined
 */
const getUserInitials = (user: ICurrentUser | undefined): string => {
  if (!user || !user.firstName || !user.lastName) {
    return '';
  }
  return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
};

export { getUserInitials };
